import { Component, OnInit } from '@angular/core';
import { PhotoEditorToolsTextService } from './photo-editor-tools-text.service';
import { tap } from 'rxjs/internal/operators/tap';
import { PhotoEditorCanvasService } from '../../photo-editor-canvas/photo-editor-canvas.service';

@Component({
  selector: 'app-photo-editor-tools-text',
  templateUrl: './photo-editor-tools-text.component.html',
  styleUrls: ['./photo-editor-tools-text.component.scss']
})
export class PhotoEditorToolsTextComponent implements OnInit {

  currentFontColor;
  tool = {
    active: false,
    id: 'text',
    cursor: 'text'
  };

  constructor(private photoEditorCanvasService: PhotoEditorCanvasService) { }

  ngOnInit() {
    this._listenSelectedTextTool();
  }

  public selectTextTool() {
    this.photoEditorCanvasService.selectTool(this.tool);
  }

  public _listenSelectedTextTool() {
    this.photoEditorCanvasService.listenSelectedTool().pipe(
      tap(res => res && res.id === 'text' ? this.tool.active = !this.tool.active : this.tool.active = false)
    ).subscribe();
  }

}
